module.exports = __webpack_public_path__ + "images/apple-120.png";